{
  "$schema": "http://json-schema.org/draft-07/schema#",
  "$id": "https://basksoft.ai/schemas/baskreport-report-ir.json",
  "title": "BaskReport 报表中间层（Report IR）",
  "description": "AI 生成的精简报表描述。转换器据此编译为 BaskReport XML。坐标从 1 开始，(row,col) 唯一标识单元格。",
  "type": "object",
  "required": ["rowCount", "columnCount", "cells"],
  "additionalProperties": false,
  "properties": {
    "name": { "type": "string", "description": "报表名称（提示用，不影响引擎）。" },
    "rowCount": { "type": "integer", "minimum": 1, "description": "网格总行数，转换器补全空白单元格到此值。" },
    "columnCount": { "type": "integer", "minimum": 1, "description": "网格总列数。" },
    "reportType": {
      "type": "string",
      "enum": ["detail", "group", "crosstab", "multi-header", "param-query"],
      "description": "报表类型，可选，缺省按单元格自动推断。用于构建器分发。"
    },
    "title": { "type": "string", "description": "预览标题表达式，缺省 fileName()。" },
    "rows": {
      "type": "array",
      "description": "行定义，未列出的行取默认行高。",
      "items": {
        "type": "object",
        "required": ["num"],
        "additionalProperties": false,
        "properties": {
          "num": { "type": "integer", "minimum": 1 },
          "height": { "type": "number", "minimum": 1, "description": "行高（pt）。" },
          "band": { "type": "string", "enum": ["headerrepeat", "none"], "description": "headerrepeat=每页重复（表头行）。" },
          "lock": { "type": "boolean", "description": "是否锁定行。" }
        }
      }
    },
    "columns": {
      "type": "array",
      "description": "列定义，未列出的列取默认列宽。",
      "items": {
        "type": "object",
        "required": ["num"],
        "additionalProperties": false,
        "properties": {
          "num": { "type": "integer", "minimum": 1 },
          "width": { "type": "number", "minimum": 1, "description": "列宽（mm）。" },
          "lock": { "type": "boolean" }
        }
      }
    },
    "cells": {
      "type": "array",
      "minItems": 1,
      "description": "稀疏单元格描述，仅写有内容的格子。",
      "items": { "$ref": "#/$defs/cell" }
    },
    "datasets": {
      "type": "array",
      "description": "数据集列表。",
      "items": { "$ref": "#/$defs/dataset" }
    },
    "datasources": {
      "type": "array",
      "description": "数据源列表，link by name。",
      "items": { "$ref": "#/$defs/datasource" }
    },
    "paper": { "$ref": "#/$defs/paper" },
    "watermark": { "$ref": "#/$defs/watermark", "description": "报表水印（对应 XML <setting> 内的 <watermaker>）。" },
    "parameters": {
      "type": "array",
      "description": "查询参数（参数报表用）。",
      "items": { "$ref": "#/$defs/parameter" }
    },
    "parameterForm": {
      "type": "array",
      "description": "参数查询表单元素（对应 XML <form-element>）。",
      "items": { "$ref": "#/$defs/formElement" }
    },
    "fill": { "$ref": "#/$defs/fill", "description": "填报配置（仅填报类报表有）。" }
  },
  "$defs": {
    "cell": {
      "type": "object",
      "required": ["row", "col"],
      "additionalProperties": false,
      "properties": {
        "row": { "type": "integer", "minimum": 1 },
        "col": { "type": "integer", "minimum": 1 },
        "name": { "type": "string", "pattern": "^[A-Z]+[1-9][0-9]*$", "description": "可选，缺省由 (row,col) 推导如 A1。" },
        "content": { "$ref": "#/$defs/content" },
        "expand": { "type": "string", "enum": ["none", "down", "right"], "description": "none=静态；down=随数据向下扩展；right=向右扩展。" },
        "left": { "type": "string", "description": "左父格坐标(A1)或 default；缺省自动推导。" },
        "top": { "type": "string", "description": "上父格坐标(A1)或 default。" },
        "rowspan": { "type": "integer", "minimum": 1, "description": "合并行数，缺省1；>1 表示纵向合并（被覆盖格不写）。" },
        "colspan": { "type": "integer", "minimum": 1, "description": "合并列数，缺省1。" },
        "visible": { "type": "boolean", "description": "缺省 true。" },
        "forcePagingBefore": { "type": "boolean" },
        "forcePaging": { "type": "boolean" },
        "style": { "$ref": "#/$defs/style" },
        "control": { "$ref": "#/$defs/cellControl", "description": "录入控件（填报）。" },
        "facade": { "$ref": "#/$defs/cellFacade", "description": "显示值映射。" }
      }
    },
    "cellControl": {
      "type": "object",
      "required": ["type"],
      "additionalProperties": false,
      "properties": {
        "type": { "type": "string", "description": "控件类型，如 text/select/date。" },
        "visible": { "type": "boolean" },
        "enableEmpty": { "type": "boolean" },
        "enableEdit": { "type": "boolean" },
        "enableCustom": { "type": "boolean" },
        "datePattern": { "type": "string" },
        "verify": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "type": { "type": "string" },
            "minLength": { "type": "integer" },
            "maxLength": { "type": "integer" },
            "min": { "type": "number" },
            "max": { "type": "number" }
          }
        },
        "binding": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "type": { "type": "string" },
            "customData": {
              "type": "array",
              "items": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "label": { "type": "string" },
                  "value": { "type": "string" }
                }
              }
            }
          }
        }
      }
    },
    "cellFacade": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "mappingType": { "type": "string" },
        "showOriginalValueOnMappingFail": { "type": "boolean" },
        "customMappingData": {
          "type": "array",
          "items": {
            "type": "object",
            "additionalProperties": false,
            "properties": {
              "label": { "type": "string" },
              "value": { "type": "string" }
            }
          }
        }
      }
    },
    "content": {
      "type": "object",
      "required": ["kind"],
      "additionalProperties": false,
      "properties": {
        "kind": { "type": "string", "enum": ["text", "expression", "dataset", "crosstab"] },
        "value": { "type": "string", "description": "text/expression 的内容。expression 以 = 开头，如 =sum(D1)。" },
        "dataset": { "type": "string", "description": "dataset 模式的 datasets[].name。" },
        "field": { "type": "string", "description": "dataset 模式的字段名。" },
        "aggregate": { "type": "string", "enum": ["none", "group", "conditiongroup", "expressiongroup", "select", "sum", "avg", "max", "min", "count", "countd", "percentile", "variance", "std"], "description": "dataset 聚合（对齐官方 AggregateType 全集）：group=分组去重；conditiongroup=条件分组；expressiongroup=表达式分组；sum=求和；count=计数；countd=去重计数；avg=平均；max/min=极值；percentile=百分位；variance=方差；std=标准差；none/select=明细（序列化时 none 也翻译为官方 select）。" },
        "groupExpression": { "type": "string", "description": "表达式分组（aggregate=expressiongroup）的分组表达式：# 代表当前字段值，如 formatDate(#,\"yyyy\") 按年、formatDate(#,\"yyyy-MM\") 按月；序列化为官方 <group-expression>。" },
        "direction": { "type": "string", "enum": ["down", "right"] },
        "cornerLabels": {
          "type": "object",
          "description": "斜线表头角区分区文字：列维度标签在前、行维度标签在后，顺序即 <item> 顺序（仅序列化阶段用于生成 <item>，IR 不写几何）。",
          "additionalProperties": false,
          "properties": {
            "row": { "type": "array", "items": { "type": "string" } },
            "col": { "type": "array", "items": { "type": "string" } }
          }
        },
        "width": { "type": "number", "description": "斜线表头角区宽度 px，缺省 98.3。" },
        "height": { "type": "number", "description": "斜线表头角区高度 px，缺省 58.5。" },
        "items": {
          "type": "array",
          "description": "斜线分区文字（斜线两侧的维度标题）。",
          "items": {
            "type": "object",
            "required": ["degree", "xPos", "yPos", "text"],
            "additionalProperties": false,
            "properties": {
              "degree": { "type": "number", "description": "文字倾斜角度（度）。" },
              "xPos": { "type": "number", "description": "文字 x 坐标（px）。" },
              "yPos": { "type": "number", "description": "文字 y 坐标（px）。" },
              "text": { "type": "string", "description": "分区标题文本。" }
            }
          }
        },
        "base64Data": { "type": "string", "description": "crosstab 斜线 PNG base64（可选，缺省由引擎根据内容动态生成）。" },
        "conditions": {
          "type": "array",
          "description": "主子报表关联条件：子数据按父字段过滤。",
          "items": { "$ref": "#/$defs/datasetCondition" }
        }
      },
      "allOf": [
        {
          "if": { "properties": { "kind": { "const": "dataset" } } },
          "then": { "required": ["dataset", "field"] }
        },
        {
          "if": { "properties": { "kind": { "const": "text" } } },
          "then": { "required": ["value"] }
        },
        {
          "if": { "properties": { "kind": { "const": "expression" } } },
          "then": { "required": ["value"] }
        }
      ]
    },
    "style": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "align": { "type": "string", "enum": ["left", "center", "right"] },
        "valign": { "type": "string", "enum": ["top", "middle", "bottom"] },
        "forecolor": { "type": "string", "pattern": "^#[0-9A-Fa-f]{6}$" },
        "bgcolor": { "type": "string", "pattern": "^#[0-9A-Fa-f]{6}$" },
        "fontFamily": { "type": "string" },
        "fontSize": { "type": "number", "description": "字号；缺省由序列化端兜底 DEFAULTS.fontSize（10）。默认不写，仅显式配置才出现。" },
        "bold": { "type": "boolean", "description": "加粗。官方 CellDefinitionParser 读取的布尔键为 bold（非 fontWeight/font-weight）。" },
        "italic": { "type": "boolean", "description": "斜体。官方键为 italic（非 fontStyle/font-style）。" },
        "underline": { "type": "boolean", "description": "下划线。官方键为 underline。" },
        "lineThrough": { "type": "boolean", "description": "删除线。官方键为 line-through（非 strikethrough）。" },
        "textDirection": { "type": "string", "description": "文本方向，如 horizontal/vertical。官方键 text-direction。" },
        "letterSpacing": { "type": "number", "description": "字距。官方键 letter-spacing。" },
        "visible": { "type": "boolean", "description": "是否可见。官方键 visible。" },
        "format": { "type": "string", "description": "格式串，如 #.## 或 yyyy-MM-dd。" },
        "formatType": { "type": "string", "enum": ["text", "date", "currency", "number", "custom"], "description": "官方 FormatType 枚举。" },
        "datasetCondition": {
      "type": "object",
      "required": ["left", "op", "valueType"],
      "additionalProperties": false,
      "properties": {
        "left": { "type": "string", "description": "关联字段名（本数据集字段），对应 XML condition 的 left。" },
        "op": { "type": "string", "enum": ["==", "!=", ">", ">=", "<", "<=", "contains", "notContains", "startsWith", "notStartsWith", "endsWith", "notEndsWith", "in", "notIn"] },
        "valueType": { "type": "string", "enum": ["dataset", "expression", "string"], "description": "dataset=与另一数据集字段关联；expression=表达式值；string=常量字符串。" },
        "dataset": { "type": "string", "description": "valueType=dataset 时，关联的数据集名。" },
        "field": { "type": "string", "description": "valueType=dataset 时，关联的字段名。" },
        "value": { "type": "string", "description": "valueType=expression/string 时的比较值。" }
      }
    },
    "columnBand": {
      "type": "object",
      "required": ["cell", "number"],
      "additionalProperties": false,
      "properties": {
        "cell": { "type": "string", "pattern": "^[A-Z]+[1-9][0-9]*$", "description": "分栏起始单元格坐标（A1 风格），如 B2。" },
        "number": { "type": "integer", "minimum": 1, "description": "每栏列数，如 10。" }
      }
    },
    "border": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "left": { "$ref": "#/$defs/border" },
            "right": { "$ref": "#/$defs/border" },
            "top": { "$ref": "#/$defs/border" },
            "bottom": { "$ref": "#/$defs/border" }
          }
        },
        "render": {
          "type": "array",
          "description": "条件样式。",
          "items": { "$ref": "#/$defs/render" }
        }
      }
    },
    "datasetCondition": {
      "type": "object",
      "required": ["left", "op", "valueType"],
      "additionalProperties": false,
      "properties": {
        "left": { "type": "string", "description": "关联字段名（本数据集字段），对应 XML condition 的 left。" },
        "op": { "type": "string", "enum": ["==", "!=", ">", ">=", "<", "<=", "contains", "notContains", "startsWith", "notStartsWith", "endsWith", "notEndsWith", "in", "notIn"] },
        "valueType": { "type": "string", "enum": ["dataset", "expression", "string"], "description": "dataset=与另一数据集字段关联；expression=表达式值；string=常量字符串。" },
        "dataset": { "type": "string", "description": "valueType=dataset 时，关联的数据集名。" },
        "field": { "type": "string", "description": "valueType=dataset 时，关联的字段名。" },
        "value": { "type": "string", "description": "valueType=expression/string 时的比较值。" }
      }
    },
    "columnBand": {
      "type": "object",
      "required": ["cell", "number"],
      "additionalProperties": false,
      "properties": {
        "cell": { "type": "string", "pattern": "^[A-Z]+[1-9][0-9]*$", "description": "分栏起始单元格坐标（A1 风格），如 B2。" },
        "number": { "type": "integer", "minimum": 1, "description": "每栏列数，如 10。" }
      }
    },
    "border": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "style": { "type": "string", "enum": ["solid", "dashed", "dotted", "none"] },
        "width": { "type": "number", "minimum": 0 },
        "color": { "type": "string", "pattern": "^#[0-9A-Fa-f]{6}$" }
      }
    },
    "render": {
      "type": "object",
      "required": ["leftExpression", "op", "rightExpression"],
      "additionalProperties": false,
      "properties": {
        "scope": { "type": "string", "enum": ["cell", "row"] },
        "bgcolor": { "type": "string", "pattern": "^#[0-9A-Fa-f]{6}$" },
        "color": { "type": "string", "pattern": "^#[0-9A-Fa-f]{6}$" },
        "bold": { "type": "boolean" },
        "italic": { "type": "boolean" },
        "underline": { "type": "boolean" },
        "leftExpression": { "type": "string", "description": "如 C4，引用同一坐标单元格数据。" },
        "op": { "type": "string", "enum": ["==", "!=", ">", ">=", "<", "<=", "contains", "notContains", "startsWith", "notStartsWith", "endsWith", "notEndsWith", "in", "notIn"] },
        "rightExpression": { "type": "string", "description": "如 1000 或 \"值\"（字符串加引号）。" }
      }
    },
    "dataset": {
      "type": "object",
      "required": ["name", "type", "datasource", "fields"],
      "additionalProperties": false,
      "properties": {
        "name": { "type": "string", "description": "数据集名称，单元格 dataset 模式引用它。" },
        "type": { "type": "string", "enum": ["sql", "buildin", "bean"] },
        "datasource": { "type": "string", "description": "关联的 datasources[].name。" },
        "sql": { "type": "string", "description": "type=sql 时的查询语句。" },
        "readFieldRemark": { "type": "boolean" },
        "data": { "type": "string", "description": "内联数据（builtin 数据集），JSON 字符串。" },
        "fields": {
          "type": "array",
          "minItems": 0,
          "items": {
            "type": "object",
            "required": ["name", "type"],
            "additionalProperties": false,
            "properties": {
              "name": { "type": "string" },
              "label": { "type": "string" },
              "type": { "type": "string", "enum": ["string", "number", "date", "boolean"] }
            }
          }
        }
      }
    },
    "datasource": {
      "type": "object",
      "required": ["name", "type"],
      "additionalProperties": false,
      "properties": {
        "name": { "type": "string", "description": "数据源别名，被 datasets[].datasource 引用。" },
        "type": { "type": "string", "description": "如 mysql / oracle。" },
        "kind": {
          "type": "string",
          "enum": ["buildin", "server"],
          "default": "buildin",
          "description": "buildin=报表内创建内置数据源（配合 buildinDatasource）；server=引用服务端已配置数据源（推荐，按 id 引用，不在报表内重复定义连接）。"
        },
        "id": { "type": "string", "description": "服务端数据源 ID（kind=server 必填），如 samplecenter-jdbc；序列化写入 <datasource id=...>。" },
        "datasourceType": { "type": "string", "enum": ["custom", "jndi", "jdbc", "virtual", "api", "adapt"], "description": "server 分支取值 jdbc/virtual/api/adapt（来自 load-datasource-defs 的 type，缺省 jdbc）；buildin 分支取值 custom/jndi。" },
        "validationQuery": { "type": "string" },
        "buildinDatasource": { "type": "string", "description": "内置数据源名，如 SampleCenterDatasource（仅 kind=buildin 生效）。" }
      }
    },
    "paper": {
      "type": "object",
      "additionalProperties": false,
      "properties": {
        "paper": { "type": "string", "enum": ["A4", "A5", "A6", "B5", "custom"] },
        "paperWidth": { "type": "number" },
        "paperHeight": { "type": "number" },
        "marginTop": { "type": "number" },
        "marginBottom": { "type": "number" },
        "marginLeft": { "type": "number" },
        "marginRight": { "type": "number" },
        "orientation": { "type": "string", "enum": ["portrait", "landscape"] },
        "columns": {
          "type": "array",
          "description": "分栏定义（列分栏报表），每个分栏输出 <column cell=.. number=../>。",
          "items": { "$ref": "#/$defs/columnBand" }
        }
      }
    },
    "watermark": {
      "type": "object",
      "required": ["text"],
      "additionalProperties": false,
      "properties": {
        "text": { "type": "string", "description": "水印文本。" },
        "left": { "type": "number", "description": "水印左侧坐标 px，缺省 10。" },
        "top": { "type": "number", "description": "水印顶部坐标 px，缺省 5。" },
        "rotate": { "type": "number", "description": "旋转角度（度），缺省 -30。" },
        "forecolor": { "type": "string", "pattern": "^#[0-9A-Fa-f]{6}$", "description": "文字颜色，缺省 #dddddd。" },
        "fontSize": { "type": "number", "description": "字号，缺省 40。" },
        "fontFamily": { "type": "string", "description": "字体，缺省 微软雅黑。" },
        "bold": { "type": "boolean" },
        "italic": { "type": "boolean" },
        "underline": { "type": "boolean" }
      }
    },
    "parameter": {
      "type": "object",
      "required": ["name"],
      "additionalProperties": false,
      "properties": {
        "name": { "type": "string" },
        "label": { "type": "string" },
        "type": { "type": "string", "enum": ["string", "number", "boolean", "date", "datetime", "list"] },
        "defaultValue": { "type": "string" },
        "editorType": { "type": "string", "description": "查询表单编辑器类型，如 text/select/date。" },
        "width": { "type": "number" },
        "required": { "type": "boolean" },
        "left": { "type": "number" },
        "top": { "type": "number" },
        "submitOnChange": { "type": "boolean" },
        "applyPrefixSuffixWhenEmpty": { "type": "boolean" },
        "binding": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "type": { "type": "string" },
            "customData": {
              "type": "array",
              "items": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "label": { "type": "string" },
                  "value": { "type": "string" }
                }
              }
            }
          }
        }
      }
    },
    "formElement": {
      "type": "object",
      "required": ["name", "formType"],
      "additionalProperties": false,
      "properties": {
        "name": { "type": "string" },
        "formType": { "type": "string", "description": "param/submit 等。" },
        "paramType": { "type": "string" },
        "label": { "type": "string" },
        "editorType": { "type": "string" },
        "width": { "type": "number" },
        "required": { "type": "boolean" },
        "left": { "type": "number" },
        "top": { "type": "number" },
        "submitOnChange": { "type": "boolean" },
        "applyPrefixSuffixWhenEmpty": { "type": "boolean" },
        "binding": {
          "type": "object",
          "additionalProperties": false,
          "properties": {
            "type": { "type": "string" },
            "customData": {
              "type": "array",
              "items": {
                "type": "object",
                "additionalProperties": false,
                "properties": {
                  "label": { "type": "string" },
                  "value": { "type": "string" }
                }
              }
            }
          }
        }
      }
    },
    "fillField": {
      "type": "object",
      "required": ["name", "type", "value"],
      "additionalProperties": false,
      "properties": {
        "name": { "type": "string" },
        "type": { "type": "string" },
        "primaryKey": { "type": "boolean" },
        "autoIncrement": { "type": "boolean" },
        "valueType": { "type": "string" },
        "value": { "type": "string", "description": "取值单元格坐标（A1 风格），如 A2。" }
      }
    },
    "fillSubmit": {
      "type": "object",
      "required": ["name", "datasource", "table", "fields"],
      "additionalProperties": false,
      "properties": {
        "name": { "type": "string" },
        "type": { "type": "string" },
        "submitType": { "type": "string" },
        "datasource": { "type": "string" },
        "table": { "type": "string" },
        "fields": { "type": "array", "items": { "$ref": "#/$defs/fillField" } }
      }
    },
    "fill": {
      "type": "object",
      "required": ["submit"],
      "additionalProperties": false,
      "properties": {
        "submit": { "$ref": "#/$defs/fillSubmit" }
      }
    }
  }
}
